/* eslint-disable camelcase */
export const COMFORT_ZONE_WIDTH = 'comfort_zone_width'
export const COMFORT_ZONE_WIDTH_VALUES = ['>= 6 ft', '< 6 ft']
export const SIDEWALK_ACCESSIBILITY = 'sidewalk_accessibility'
export const SIDEWALK_ACCESSIBILITY_VALUES = [
  'Few or no driveways cross the sidewalk comfort zone',
  'Flat driveways cross the sidewalk comfort zone',
  'Sloped driveways cross the sidewalk comfort zone'
]
export const LIGHTING = 'lighting'
export const LIGHTING_VALUES = [
  'Pedestrian-scale lighting',
  'Roadway lighting only',
  'No lighting'
]
export const PEDESTRIAN_FACILITY_TYPE = 'pedestrian_facility_type'
export const PEDESTRIAN_FACILITY_TYPE_VALUES = [
  'Detached Sidewalks',
  'Attached Sidewalks',
  'No Sidewalk'
]
export const BUFFER_WIDTH = 'buffer_width'
export const BUFFER_WIDTH_VALUES = ['>=14 ft', '<14 ft']

export const BUFFER_QUALITY = 'buffer_quality'
export const BUFFER_QUALITY_VALUES = [
  'High buffer (e.g. lush landscaping or parklet)',
  'Physical barrier (e.g. parked cars or bicycle parking)',
  'Width buffer (e.g. painted bike lane or bus lane)'
]

export const LANDSCAPE_BUFFER_STREET_TREES = 'landscape_buffer_street_trees'
export const LANDSCAPE_BUFFER_STREET_TREES_VALUES = [
  'Continuous',
  'Discontinuous',
  'No landscaping'
]

export const USABLE_SIDEWALK_WIDTH = 'usable_sidewalk_width'
export const USABLE_SIDEWALK_WIDTH_VALUES = [
  '>= 10ft',
  '8 to 9 ft',
  '6 to 7 ft',
  '< 6ft'
]

export const SIDEWALK_QUALTIY = 'sidewalk_quality'
export const SIDEWALK_QUALTIY_VALUES = [
  'Smooth; even surface',
  'Some cracks; usable sidewalk width maintained',
  'Cracked; failing pavement'
]

export const HEAVY_VEHICLES = 'heavy_vehicles'
export const HEAVY_VEHICLES_VALUES = ['<= 5%', '6 to 7%', '>= 8%']

export const ACTIVE_BUILDING_FRONTAGE = 'active_building_frontage'
export const ACTIVE_BUILDING_FRONTAGE_VALUES = [
  'Majority of sidewalk zone has active building frontage',
  'Majority of sidewalk zone does not have active building frontage'
]

export const CROSSING_SPACING = 'crossing_spacing'
export const CROSSING_SPACING_VALUES = [
  'Crosswalks spaced 400 ft or less',
  'Crosswalks spaced > 400 ft'
]
export const SPECIAL_CONSIDERATIONS = 'special_considerations'
export const SPECIAL_CONSIDERATION_VALUES = [
  'High volume of bikes/scooters on sidewalk (or road, if no sidewalk exists)'
]
export const CROSSING_IMPROVEMENTS = 'crossing_improvements'
export const CROSSING_IMPROVEMENTS_VALUES = [
  'Yield or Stop sign present for unsignalized pedestrian crossing',
  'Curb extension or median refuge',
  'Raised crossing',
  'High visibility crosswalk markings',
  'Rectangular rapid-flashing beacon (RRFB) or pedestrian hybrid beacon (PHB)',
  'Leading pedestrian interval (LPI)'
]
export const PREVAILING_POSTED_SPEED = 'prevailing_posted_speed'
